// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invite-bean{display:inline-block;width:.48rem;height:.48rem;vertical-align:middle}.invite2-tips-wrapper{max-width:5.86667rem;padding:.21333rem .26667rem}", ""]);
// Exports
module.exports = exports;
